import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { name: 'Water Well Pump Service', path: '/services/pump-service' },
    { name: 'Water Well Repair', path: '/services/well-repair' },
    { name: 'Well Maintenance', path: '/services/maintenance' },
    { name: 'Well Inspection', path: '/services/inspection' },
    { name: 'Well Plugging', path: '/services/plugging' },
    { name: 'Well Chlorination', path: '/services/chlorination' },
  ];

  const serviceAreas = [
    'Magnolia', 'Spring', 'Tomball', 'Conroe', 'Cypress', 'Houston',
    'Katy', 'Montgomery', 'Plantersville', 'Hempstead', 'Willis', 'Brookshire'
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://77waterwell.com/wp-content/uploads/2023/10/77-Water-Well-Red-Blue-Logo-1.png"
              alt="77 Water Well Inc."
              className="h-16 w-16 mb-4"
            />
            <h3 className="text-white font-bold text-lg mb-3">77 Water Well Inc.</h3>
            <p className="text-sm mb-4">
              Family-owned water well service company providing reliable, expert solutions throughout North Houston, Texas.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/77waterwell" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-primary-600 transition-colors">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/77waterwell/" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-primary-600 transition-colors">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://twitter.com/77waterwell" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-primary-600 transition-colors">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.youtube.com/@77waterwell" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-primary-600 transition-colors">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="hover:text-primary-400 transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Service Areas</h4>
            <ul className="grid grid-cols-2 gap-2 text-sm">
              {serviceAreas.map((area) => (
                <li key={area} className="flex items-center gap-1">
                  <i className="fas fa-map-marker-alt text-primary-500 text-xs"></i>
                  <span>{area}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <strong className="text-white block mb-1">Address:</strong>
                300 Abney Ln<br />
                Magnolia, TX 77355
              </li>
              <li>
                <strong className="text-white block mb-1">Phone:</strong>
                <a href="tel:2814564556" className="hover:text-primary-400 transition-colors whitespace-nowrap">
                  (281) 456-4556
                </a>
              </li>
              <li>
                <strong className="text-white block mb-1">Email:</strong>
                <a href="mailto:service@77waterwell.com" className="hover:text-primary-400 transition-colors">
                  service@77waterwell.com
                </a>
              </li>
              <li>
                <strong className="text-white block mb-1">Hours:</strong>
                Mon-Fri: 8:00 AM - 5:00 PM<br />
                <span className="text-accent-400 font-semibold">24/7 Emergency Service</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p>&copy; {currentYear} 77 Water Well Inc. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/contact" className="hover:text-primary-400 transition-colors whitespace-nowrap">
                Privacy Policy
              </Link>
              <Link to="/contact" className="hover:text-primary-400 transition-colors whitespace-nowrap">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 lg:hidden bg-primary-600 text-white p-4 shadow-lg z-40">
        <div className="flex gap-3">
          <a
            href="tel:2814564556"
            className="flex-1 bg-white text-primary-600 py-3 rounded-lg font-bold text-center hover:bg-gray-100 transition-colors whitespace-nowrap"
          >
            <i className="fas fa-phone-alt mr-2"></i>
            Call Now
          </a>
          <Link
            to="/contact"
            className="flex-1 bg-accent-500 text-white py-3 rounded-lg font-bold text-center hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            <i className="fas fa-envelope mr-2"></i>
            Get Quote
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;